/**
 * @desc 官网 + 公共模块
 */

import { trackEvent } from '@/omega/index';

// 首页曝光
export function homePageView(options) {
  trackEvent({
    eventId: 'sailing_c_e_homepage_common_sw',
    eventLabel: '首页曝光',
    attrs: {
      ...options,
    },
  });
}

// 首页点击
export function homePageClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_homepage_common_ck',
    eventLabel: '首页点击',
    attrs: {
      ...options,
    },
  });
}

// 侧边栏点击
export function sideBarClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_sidebar_common_ck',
    eventLabel: '侧边栏点击',
    attrs: {
      ...options,
    },
  });
}

// 顶导航栏点击
export function topNavClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_topnavbar_common_ck',
    eventLabel: '顶导航栏点击',
    attrs: {
      ...options,
    },
  });
}

// 顶导航栏账号个人中心曝光
export function topUserCenterView(options) {
  trackEvent({
    eventId: 'sailing_c_e_topnavbar_popup_sw',
    eventLabel: '顶导航栏点击',
    attrs: {
      ...options,
    },
  });
}

// 顶导航栏账号弹窗点击
export function topUserCenterClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_topnavbar_popup_ck',
    eventLabel: '顶导航栏账号弹窗点击',
    attrs: {
      ...options,
    },
  });
}

// 退出登录弹窗点击
export function logoutPopupClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_topnavbar_logout_popup_ck',
    eventLabel: '退出登录弹窗点击',
    attrs: {
      ...options,
    },
  });
}

export function accountShow() {
  trackEvent({
    eventId: 'sailing_c_e_accountpage_info_common_sw',
    eventLabel: '账号管理页曝光',
  });
}

// 账号管理页取消点击
export function cancelUpdateAccountClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_accountpage_info_cancel_ck',
    eventLabel: '账号管理页取消点击',
    attrs: {
      ...options,
    },
  });
}

// 账号管理页点击
export function accountBtnClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_accountpage_info_common_ck',
    eventLabel: '账号管理页点击',
    attrs: {
      ...options,
    },
  });
}

// 商家基础信息曝光
export function addAccountInfoView(options = {}) {
  trackEvent({
    eventId: 'sailing_c_e_registrationpage_merchant_common_sw',
    eventLabel: '商家基础信息曝光',
    attrs: {
      ...options,
    },
  });
}

// 商家基础信息submit点击
export function addAccountSubmitClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_registrationpage_merchant_submit_ck',
    eventLabel: '商家基础信息submit点击',
    attrs: {
      ...options,
    },
  });
}

// 账号管理页确认点击
export function accountConfirmClick(options) {
  trackEvent({
    eventId: 'sailing_c_e_accountpage_info_confirm_ck',
    eventLabel: '账号管理页确认点击',
    attrs: {
      ...options,
    },
  });
}

// 挽留弹窗曝光
export function leaveConfirmView(options) {
  if (!options?.event_type) {
    return;
  }
  trackEvent({
    eventId: 'sailing_c_e_sidebar_retain_popup_sw',
    eventLabel: '侧边栏挽留弹窗曝光',
    attrs: {
      ...options,
    },
  });
}

// 挽留弹窗点击
export function leaveConfirmClick(options) {
  if (!options?.event_type) {
    return;
  }
  trackEvent({
    eventId: 'sailing_c_e_sidebar_retain_popup_ck',
    eventLabel: '侧边栏挽留弹窗点击',
    attrs: {
      ...options,
    },
  });
}
